import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { SharedDirectivesModule } from 'src/app/shared/modules/shared-directives.module';
import { Permission } from 'src/app/lib/rbac.config';

@Component({
  selector: 'app-toggle-add-btn',
  standalone: true,
  imports: [CommonModule, MatTooltipModule, SharedDirectivesModule],
  template: `
    <button
      class="custom-btn btn-light-red px-4 py-1 flex items-center"
      [ngClass]="[textSize, fontWeight]"
      [appDisableWithoutPermission]="permission"
      matTooltip
      (click)="onClick()">
      <span class="material-icons text-white mr-1" [ngClass]="{
        'text-sm': textSize === 'text-xs',
        'text-base': textSize === 'text-sm',
        'text-lg': textSize === 'text-base',
        'text-xl': textSize === 'text-lg'
      }">
        {{ icon }}
      </span>
      {{ label }}
    </button>
  `,
  styleUrls: ['./custom-toggle-add-btn.component.scss']
})
export class CustomToggleAddBtnComponent {
  @Input() label = String('Add_Button_Label');
  @Input() icon = String('Add_Icon_Name');
  @Input() permission!: Permission | Permission[];
  @Input() textSize: 'text-xs' | 'text-sm' | 'text-base' | 'text-lg' = 'text-xs';
  @Input() fontWeight: 'font-normal' | 'font-medium' | 'font-semibold' | 'font-bold' = 'font-semibold';

  @Output() clicked = new EventEmitter<void>();

  onClick() {
    this.clicked.emit();
  }
}
